import request from '@/utils/request'


// 查询直播间连麦列表
export function listSeedingwheat(query) {
  return request({
    url: '/live/seedingwheat/list',
    method: 'get',
    params: query
  })
}

// 查询直播间连麦分页
export function pageSeedingwheat(query) {
  return request({
    url: '/live/seedingwheat/page',
    method: 'get',
    params: query
  })
}

// 查询直播间连麦详细
export function getSeedingwheat(data) {
  return request({
    url: '/live/seedingwheat/detail',
    method: 'get',
    params: data
  })
}

// 新增直播间连麦
export function addSeedingwheat(data) {
  return request({
    url: '/live/seedingwheat/add',
    method: 'post',
    data: data
  })
}

// 修改直播间连麦
export function updateSeedingwheat(data) {
  return request({
    url: '/live/seedingwheat/edit',
    method: 'post',
    data: data
  })
}

// 删除直播间连麦
export function delSeedingwheat(data) {
  return request({
    url: '/live/seedingwheat/delete',
    method: 'post',
    data: data
  })
}
